import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"system-3"},"children":[{"tag":"g","attrs":{"id":"fill1"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M16.9229 21H21V16.9229C21 15.3113 19.6888 14 18.0771 14H14V18.0772C14 19.6887 15.3112 21 16.9229 21Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M7.07713 21H3V16.9229C3 15.3113 4.31124 14 5.92287 14H10V18.0772C10 19.6887 8.68876 21 7.07713 21Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M16.9229 3H21V7.07705C21 8.68873 19.6888 10 18.0771 10H14V5.92277C14 4.31127 15.3112 3 16.9229 3Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M7.07713 3H3V7.07705C3 8.68873 4.31124 10 5.92287 10H10V5.92277C10 4.31127 8.68876 3 7.07713 3Z"}}]},{"tag":"g","attrs":{"id":"stroke1"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M16.9229 21H21V16.9229C21 15.3113 19.6888 14 18.0771 14H14V18.0772C14 19.6887 15.3112 21 16.9229 21Z","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M7.07713 21H3V16.9229C3 15.3113 4.31124 14 5.92287 14H10V18.0772C10 19.6887 8.68876 21 7.07713 21Z","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M16.9229 3H21V7.07705C21 8.68873 19.6888 10 18.0771 10H14V5.92277C14 4.31127 15.3112 3 16.9229 3Z","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M7.07713 3H3V7.07705C3 8.68873 4.31124 10 5.92287 10H10V5.92277C10 4.31127 8.68876 3 7.07713 3Z","strokeWidth":"props.strokeWidth"}}]}]}]};

const System3 = Vue.extend<IconProps>({
  name: 'System3Icon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'system-3',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default System3;
